import { useState } from 'react';
import { CSwitchWithLabel, InfoCard, OfficialDocumentModal } from 'components/molecules';
import { useTranslation } from 'react-i18next';
import { CContainedButton, COutlinedButton } from 'components/atoms';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { resetVideoCall, setVideoCall } from 'store/app/app-slice';
import { Divider } from '@mui/material';
import { DocumentCode } from 'components/molecules/modal/official-document';

type Props = {
  doctorPhoto?: string;
  doctorTitle?: string;
  doctorName?: string;
};
export default function AccessPermission({ doctorPhoto, doctorTitle, doctorName }: Props) {
  const { t } = useTranslation(['translation', 'common']);
  const videoCall = useAppSelector((state) => state.app.videoCall);
  const dispatch = useAppDispatch();
  const [accessGranted, setAccessGranted] = useState({
    consent: false,
    microphone: false,
    camera: false,
  });

  return (
    <div className="flex w-[90vw] max-w-sm items-center justify-center">
      <div className="flex flex-col gap-6 p-4">
        <InfoCard type="info" description={t('info.access-permission')} />

        <OfficialDocumentModal
          field={{
            value: accessGranted.consent,
            onChange: () => setAccessGranted({ ...accessGranted, consent: !accessGranted.consent }),
          }}
          actionType="checkbox"
          documentCode={DocumentCode.ONAM_FORMU}
          isOpenDetailDocument
        />

        <div className="flex flex-col gap-4">
          <CSwitchWithLabel
            checked={accessGranted.camera}
            label={t('common:camera')}
            labelPlacement="start"
            className="mx-0 justify-between text-neutral"
            onChange={(event, checked) => {
              setAccessGranted({ ...accessGranted, camera: checked });
            }}
          />

          <Divider className="w-full" />

          <CSwitchWithLabel
            checked={accessGranted.microphone}
            label={t('common:microphone')}
            labelPlacement="start"
            className="mx-0 justify-between text-neutral"
            onChange={(event, checked) => {
              setAccessGranted({ ...accessGranted, microphone: checked });
            }}
          />
        </div>

        <div className="flex gap-4">
          <COutlinedButton fullWidth onClick={() => dispatch(resetVideoCall())}>
            {t('common:close')}
          </COutlinedButton>

          <CContainedButton
            disabled={Object.values(accessGranted).includes(false)}
            fullWidth
            onClick={() =>
              dispatch(
                setVideoCall({
                  ...videoCall,
                  isAccessGranted: !Object.values(accessGranted).includes(false),
                })
              )
            }
          >
            {t('common:confirm')}
          </CContainedButton>
        </div>
      </div>
    </div>
  );
}

